import {
	RefObject,
	useCallback,
	useEffect,
	useMemo,
	useRef
} from "react";
import { CommentListHandle } from "../HubCommentSection";
import { isNil } from "client/Misc/utils";

export type CommentNavigationData = {
	commentListRef: RefObject<CommentListHandle | null>;
	navigateToCommentIdHandler: (commentId: number) => void;
};

export function useCommentNavigation(
	initialCommentIdToFocus?: number
): CommentNavigationData {
	const commentListRef: RefObject<CommentListHandle | null> = useRef<CommentListHandle>(null);

	const navigateToCommentIdHandler = useCallback(
		(commentId: number): void => {
			commentListRef.current
				?.scrollToComment(commentId);
		},
		[]
	);

	useEffect(
		(): void => {
			if (isNil(initialCommentIdToFocus)) {
				return;
			}

			navigateToCommentIdHandler(initialCommentIdToFocus);
		},
		[initialCommentIdToFocus, navigateToCommentIdHandler]
	);

	return useMemo(
		(): CommentNavigationData => ({
			commentListRef,
			navigateToCommentIdHandler
		}),
		[navigateToCommentIdHandler]
	);
}
